// POST-UC-2.CC-1: нормализация хештегов. Общая для формы и сервера.
const TAG_PATTERN = /^[\p{L}\p{N}_]+$/u;
export const HASHTAG_MAX_LENGTH = 100;
export const HASHTAGS_MAX_COUNT = 60;

export interface HashtagsResult {
  tags: string[];
  invalid: string[];
}

/** Разбирает строку «#пять #азиатская_кухня, атмосфера» в список тегов. */
export function parseHashtagInput(text: string): string[] {
  return text
    .split(/[\s,;]+/)
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

export function normalizeHashtags(input: readonly string[]): HashtagsResult {
  const tags: string[] = [];
  const seen = new Set<string>();
  const invalid: string[] = [];
  for (const raw of input) {
    const tag = raw.trim().replace(/^#+/, '');
    if (tag.length === 0) continue;
    if (!TAG_PATTERN.test(tag) || tag.length > HASHTAG_MAX_LENGTH) {
      invalid.push(raw);
      continue;
    }
    const folded = tag.toLocaleLowerCase('ru');
    if (seen.has(folded)) continue;
    seen.add(folded);
    tags.push(tag);
  }
  if (tags.length > HASHTAGS_MAX_COUNT) {
    invalid.push(...tags.splice(HASHTAGS_MAX_COUNT));
  }
  return { tags, invalid };
}
